export const EDIT_MODELS = 'EDIT_MODELS';
